module.exports = __webpack_public_path__ + "static/title-graphic-9bb1b6929daa533783b7d916416d5dd8.svg";